import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';
//import { ListPage } from '../../pages/list/list';
//import { ListPage } from '../pages/list/list';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
import { ThanksPage } from '../../pages/thanks/thanks';
import { SignaturePage } from '../../pages/signature/signature';
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';
import { Geolocation } from '@ionic-native/geolocation';
import { Events } from 'ionic-angular';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker,
  Environment
} from '@ionic-native/google-maps';
import { stringify } from '@angular/core/src/util';

declare var google;

@Component({
  selector: 'page-ride',
  templateUrl: 'ride.html'
})

export class RidePage {
  loading: Loading;
  startbtn: boolean = true;
  drivestartbtn:boolean=true;
  dropbtn:boolean=true;

  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
    savedata: boolean = true;
    kmbegin : number;
    kmend: number;
    rating = 1;
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  items2;
  items3;
  location;
  drivergetlat;
  drivergetlang;
  routeResponse;
  task;

 //  @ViewChild(Tabs) tabs;
  @ViewChild('map') mapElement: ElementRef;

    mainarray:any;
  map: any;
  markers = [];
    wayptsnavigation = [];
     //locationpyts=[];
  labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
     labelIndex = 0;
  start = '';
  end = '';
  //directionsService = new google.maps.DirectionsService;
  //directionsDisplay = new google.maps.DirectionsRenderer;
  directionsService = new google.maps.DirectionsService;
  directionsDisplay = new google.maps.DirectionsRenderer;

  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams,private launchNavigator: LaunchNavigator,private geolocation: Geolocation) {

    this.items = navParams.get('data');
    console.log(this.items);

    let self = this;
  this.task = setInterval(function () {
  self.updatelocation();
  }, 40000);
  }

  savenow(){
    if(this.kmbegin > 0 ){
  
      let updaterate={"company_id":localStorage.getItem('company_id'),"driver_id":this.items.driver_id,"order_id":this.items.order_id,"kmbegin":this.kmbegin,'kmend':this.kmend}
              let data_parameters=updaterate;
              let method='kmstand.php';
             // console.log("Beginn: ",this.kmbegin);
             // console.log("End: ",this.kmend);
              this.authService.postData(data_parameters,method).then((result) => {
               
                this.obj = result;
                console.log(this.obj);
                
               if(this.obj.status=='true'){
               alert(this.obj.message);
               this.savedata=true;
                }
               
               else{
  
             
                }
                
                }, (err) => {
                  // Error log
              }); 
              }
            else{ alert('Bitte beide KM-Werte eingeben !'); }
      }


  updatelocation(){

   this.geolocation.getCurrentPosition().then((resp) => {
   this.drivergetlat=resp.coords.latitude;
   this.drivergetlang=resp.coords.longitude;
     console.log(resp.coords.latitude);
     console.log(resp.coords.longitude);

     }).catch((error) => {
     console.log('Error getting location', error);
     });

   let update={"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"last_loc_lat":this.drivergetlat,"last_loc_long":this.drivergetlang,"order_id":this.items.order_id}
            let data_parameters=update;
            let method='current_location_update.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
             
              this.obj = result;
              console.log(this.obj);

             if(this.obj.status=='true'){
             
             this.startbtn=false;
              }
             
             else{

           
              }
              
              }, (err) => {
                // Error log
            }); 

  }

  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
        //  this.nav.remove(index);
          // this.navCtrl.rootNav.setRoot(LoginsignupPage);  
  
           // this.viewCtrl.dismiss();
         //  this.appCtrl.getRootNav().setRoot(LoginPage);
           //this.navCtrl.setRoot(LoginsignupPage);  
          // localStorage.clear();
          // this.nav.setRoot(LoginPage);
          }
        }
      ]
    });
    alert.present();
  }
  
  waitlocation(orderid){
     //alert//
     let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });

            let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":3}
            let data_parameters=acceptride;
            let method='ride_status.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
              this.loading.present();
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
              this.loading.dismiss();
             this.startbtn=false;
              }
             
             else{

            this.loading.dismiss();
              //alert(this.obj.message);
              }
              
              }, (err) => {
                // Error log
            });
          }
        }
      ]
    });
    alert.present();
    //end//
  }
  startdrive(orderid){

    //alert//
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });
          
            let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":2}
            let data_parameters=acceptride;
            let method='ride_status.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
              this.loading.present();
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
            //  this.startbtn=false;
            //  this.startbtn=false;
           // 
           this.loading.dismiss();
             this.drivestartbtn=false;
             this.dropbtn=true;
             this.items.ridestatus=2;
              }
             
             else{
              this.loading.dismiss();
             // this.loading.dismissAll();
              //alert(this.obj.message);
              }
              
              }, (err) => {
                // Error log
            });
          }
        }
      ]
    });
    alert.present();
    //end//

  }

  droplocation(orderid){
//alert//
  let alert = this.alertCtrl.create({
  title: '',
  message: 'Sind Sie sicher ?',
  buttons: [
    {
      text: 'Abbruch',
      role: 'cancel',
      handler: () => {
        //console.log('Cancel clicked');
      }
    },
    {
      text: 'OK',
      handler: () => {
        this.loading = this.loadingCtrl.create({
          content: '',
          });

        let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":4}
        let data_parameters=acceptride;
        let method='ride_status.php';
      
        this.authService.postData(data_parameters,method).then((result) => {
          this.loading.present();
          this.obj = result;
          console.log(this.obj);
          
         if(this.obj.status=='true'){
          this.loading.dismiss();
          this.items.ridestatus=2;
          this.dropbtn=false;
          this.navCtrl.push(SignaturePage,{ data:this.items})
          }
         
         else{
          this.loading.dismiss();
          //alert(this.obj.message);
          }
          
          }, (err) => {
            // Error log
        });
      }
    }
  ]
});
alert.present();
  }

  

  startride(orderid){

    //alert//
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Sind Sie sicher ?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            this.loading = this.loadingCtrl.create({
              content: '',
              });
           
            
            let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"ridestatus":1}
            let data_parameters=acceptride;
            let method='ride_status.php';
          
            this.authService.postData(data_parameters,method).then((result) => {
              this.loading.present();
              this.obj = result;
              console.log(this.obj);
              
             if(this.obj.status=='true'){
              this.drivestartbtn=true;
             this.startbtn=false;
             this.items.ridestatus=1;
             this.loading.dismiss();
              }
             
             else{
              this.loading.dismiss();
              //alert(this.obj.message);
              }
              
              }, (err) => {
                // Error log
            });
          }
        }
      ]
    });
    alert.present();
    //end//
  }

  gonavigate(address){
  if(this.location){
    //var trackplaceaddress=document.getElementById('trackplace');
    //alert(this.location);

    if(this.location==0){

        this.launchNavigator.navigate(this.mainarray[0].location)
    }else{
        //alert(this.mainarray[this.location-1].location);
        //alert(this.mainarray[this.location].location);

        let options: LaunchNavigatorOptions = {
        start:this.mainarray[this.location-1].location,
        };
          this.launchNavigator.navigate(this.mainarray[this.location].location,options)
    }
}
else{
  alert('Bitte Adresse wählen');
}

       // this.launchNavigator.navigate(this.location)
       //this.launchNavigator.navigate([50.279306, -5.163158,50.279308, -5.163159], {
       //start: "50.342847, -4.749904"
        //});
  }
  ionViewWillEnter() {

  this.initMap();
  this.start=this.items.pickup_direction;
   this.end=this.items.drop_direction;
  
   this.calculateAndDisplayRoute();

var locationpyts=[];
   for (var k = 0; k < this.items.passengerData.length; k++) {
    if(k==0){
   locationpyts.push({
                indexid:k,
              location: this.items.passengerData[k].address,
              //text: 'Fahrer zum '+this.items.passengerData[k].address,
              text: this.items.passengerData[k].address,

             // stopover: true
            });
            }else{
              locationpyts.push({
               indexid:k,
              location: this.items.passengerData[k].address,
              //text: this.items.passengerData[k-1].address+' Nach '+this.items.passengerData[k].address,
              text: this.items.passengerData[k].address,

             // stopover: true
            });
            }
   }
   console.log('gd');
    console.log(locationpyts);
   this.mainarray= locationpyts;
//this.All();

 
  // let method='customer_order_details.php';
  // let temp={};
 
  // this.loading = this.loadingCtrl.create({
  // content: '',
  // });

  //  this.loading.present();
 //  console.log(data_parameters);

//    this.authService.postData(data_parameters,method).then((result) => {
 
//    this.obj = result;
//    console.log(this.obj);
   
//   if(this.obj.status=='true'){
//     this.items=this.obj.response;
//   //this.loading.dismissAll();
  
// //  localStorage.setItem("name",this.obj.name);
// //  localStorage.setItem("customers_id",this.obj.customers_id);
// //  localStorage.setItem("company_id",this.obj.company_id);
//   //this.navCtrl.setRoot(HomePage);
//    }
  
//   else{
//   // this.loading.dismissAll();
//    alert(this.obj.message);
//    }
   
//    }, (err) => {
//      // Error log
//  });



 
}


  initMap() {
    
    var point = {lat: this.items.drop_lat, lng: this.items.drop_log};

    //var point = {lat: 22.719568, lng: 75.857727};
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      zoom: 15,
      center: point,
      
     draggable:true,
      zoomControl: true,
      mapTypeControl: true,
      streetViewControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
     
    });

            /*this.map = new GoogleMap('map', {
          'backgroundColor': 'white',
          
          'controls': {
            'compass': true,
            'myLocationButton': true,
            'indoorPicker': true,
            'zoom': true
          },
          'gestures': {
            'scroll': true,
            'tilt': true,
            'rotate': true,
            'zoom': true
          },
          
        });*/



    //this.createMapMarker(point);
 
  
    // directionsService = new google.maps.DirectionsService();
     // directionsDisplay = new google.maps.DirectionsRenderer();

     this.directionsDisplay.setMap(this.map);
    this.directionsDisplay.setOptions( {
     
   
     } );
     //this.directionsDisplay.setPanel(document.getElementById('right-panel'));
  }

calculateAndDisplayRoute() {
 var waypts = [];
 var checkboxArray = this.items.passengerData;

console.log(checkboxArray.length);
        for (var i = 0; i < checkboxArray.length; i++) {
         if(i!=0 && i!=checkboxArray.length-1){
            waypts.push({
              location: checkboxArray[i].address,

             // stopover: true
            });

             this.wayptsnavigation.push({
              location: checkboxArray[i].address,

             // stopover: true
            });
            
             
            }
         
        }
  //console.log('checkboxArray');
   
 //console.log(waypts);
 // console.log('checkboxArray2');

    this.directionsService.route({origin: this.start,
    destination: this.end,
    waypoints: waypts,
    optimizeWaypoints: true,
     travelMode: google.maps.TravelMode['DRIVING']
    // provideRouteAlternatives: true
    }, (response, status) => {
  
        this.directionsDisplay.setDirections(response);
       // console.log(response);
      var my_route = response.routes[0];
            for (var i = 0; i < my_route.legs.length; i++) {
                var marker = new google.maps.Marker({
                    position: my_route.legs[i].start_location,
                   //label: 'A',
                    map: this.map
                });
            }
            
    
    });
  }



  /*private createMapMarker(place:any):void {
   
    var marker = new google.maps.Marker({
    map: this.map,
    position: place,
    label: '1',
    //label: labels[labelIndex++ % labels.length]

    });
    this.markers.push(marker);
    }*/

    gosign(order_data){
    this.navCtrl.push(SignaturePage,{ data:order_data});
    }
    
  
}



// WEBPACK FOOTER //
// ./src/pages/ride/ride.ts